/* eslint-disable */
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import withWidth from '@material-ui/core/withWidth';
import EmailIcon from '@material-ui/icons/Email';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/Phone';
import WorkIcon from '@material-ui/icons/Work';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import CustomPhoneInput from '../../Components/CustomPhoneInput/CustomPhoneInput.component';
import Spinner from '../../Components/Spinner/Spinner.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import EditProfilePagePropTypes from './EditProfile.page.props';
import editProfilePageStyles from './EditProfile.page.styles';
import './Profile.page.i18n';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * EditProfilePageComponent
 * @export
 * @class EditProfilePageComponent
 * @extends {React.Component<EditProfilePageComponentComposedProps, EditProfilePageComponentState>}
 */
export class EditProfilePageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<EditProfileComponentProps>}
   * @memberof EditProfilePageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`EditProfilePage`}
   * @memberof EditProfilePageComponent
   */
  static displayName = `EditProfilePage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof EditProfilePageComponent
   */

  static propTypes = EditProfilePagePropTypes;

  /**
   * Data specific to the `<EditProfilePage />` instance
   * @type {EditProfilePageComponentState}
   * @memberof EditProfilePageComponent
   */
  state = {
    // eslint-disable-next-line react/destructuring-assignment
    userInfo: this.props.userInfo,
  };

  /**
   * Handles the change event for custom phone number field
   * @param {string} id The event object
   * @param {Object} value The event object
   * @param {boolean} error The error check
   * @memberof EditProfilePageComponent
   * @returns {void} void
   */
  handleChange = (id, value, error) => {
    const { userInfo } = this.state;
    const { onUserInfoChange } = this.props;
    this.setState({ userInfo: { ...userInfo, [id]: value } }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onUserInfoChange(this.state.userInfo, error);
    });
  };

  /**
   * Render the field
   * @param {string} label The label
   * @param {string} value The value
   * @param {React.Component} icon The icon
   * @param {string} id The value
   * @param {string} type The value
   * @returns {React.Component} The rendered field
   * @memberof ProfilePageComponent
   */
  renderField = (label, value, icon, id, type, disabled) => {
    const { classes } = this.props;
    return (
      <Grid alignItems="center" classes={{ item: classes.field }} container item spacing={2} wrap="nowrap">
        <Grid classes={{ item: classes.icon }} item>
          {icon}
        </Grid>
        <Grid item xs zeroMinWidth>
          <TextField
            className={classes.spaceBottom15}
            disabled={disabled}
            fullWidth
            id={id}
            label={label}
            onChange={(event) => this.handleChange(event.target.id, event.target.value, null)}
            type={type}
            value={value}
          />
        </Grid>
      </Grid>
    );
  };

  /**
   * Render a cusotm phone number field
   * @param {string} label The label
   * @param {string} value The value
   * @param {React.Component} icon The icon
   * @param {string} id The value
   * @param {string} type The value
   * @returns {React.Component} The rendered field
   * @memberof ProfilePageComponent
   */
  renderCustomPhoneField = (label, value, icon, id, type) => {
    const { classes } = this.props;
    return (
      <Grid alignItems="center" classes={{ item: classes.field }} container item spacing={2} wrap="nowrap">
        <Grid classes={{ item: classes.icon }} item>
          {icon}
        </Grid>
        <Grid className={classes.phonePadding} item xs zeroMinWidth>
          <CustomPhoneInput
            id={id}
            label={label}
            onPhoneNumberChange={(newId, newValue, errorText) => this.handleChange(newId, newValue, errorText)}
            value={value}
          />
        </Grid>
      </Grid>
    );
  };

  /**
   * Render a cusotm phone number field
   * @param {string} label The label
   * @param {string} value The value
   * @param {React.Component} icon The icon
   * @param {string} id The value
   * @param {string} type The value
   * @returns {React.ßComponent} The rendered field
   * @memberof ProfilePageComponent
   */
  renderCustomSelectField = (label, value, icon, id, type) => {
    const { classes } = this.props;
    const { userInfo } = this.state;
    const jobTitles = [`General Manager`, `Owner`, `Accounts Payable`, `Site Manager`, `Project Manager`, `Concrete Placer`, `Sub contractor`, `Administrator`];
    return (
      <Grid alignItems="center" classes={{ item: classes.field }} container item spacing={2} wrap="nowrap">
        <Grid classes={{ item: classes.icon }} item>
          {icon}
        </Grid>
        <Grid item xs zeroMinWidth>
          <InputLabel className={classes.selectStyle}>Job Title</InputLabel>
          <Select
            className={classes.width100}
            inputProps={{
              id: `job-title`,
              name: `Job Title`,
            }}
            onChange={(val) => this.handleChange(`jobTitle`, val.target.value, null)}
            value={userInfo.jobTitle === undefined ? `none` : userInfo.jobTitle}
          >
            {jobTitles.map((displayValue, key) => {
              return (
                <MenuItem key={displayValue} value={displayValue}>
                  {displayValue}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
      </Grid>
    );
  };

  /**
   * Render the profile
   * @returns {React.Component} The rendered profile
   * @memberof EditProfilePageComponent
   */
  renderProfile() {
    const { classes, firstLogin } = this.props;
    const { userInfo } = this.state;
    if (!userInfo) {
      return <Spinner />;
    }
    const { jobTitle, email, firstName, lastName, mobilePhone, primaryPhone } = userInfo;
    return (
      <Grid container item sm={12} xs={12}>
        <Grid alignItems="center" classes={{ container: classes.profileHeader }} className={classes.spaceTop20} container item spacing={2} wrap="nowrap">
          <Grid item>
            <Avatar>
              <PersonIcon />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography variant="h5" data-mf-replace-inner={MFSDR}>{`${firstName || ''} ${lastName || ''}`}</Typography>
          </Grid>
        </Grid>
        <Grid container direction="column" item>
          {this.renderField(`First Name`, firstName, <PersonIcon />, `firstName`, `text`)}
          <div className={classes.spaceLeft25}> {this.renderField(`Last Name`, lastName, null, `lastName`, `text`)}</div>
          {this.renderField(`Email`, email, <EmailIcon />, `email`, `email`, firstLogin)}
          {this.renderCustomSelectField(`Job Title`, jobTitle, <WorkIcon />, `jobTitle`, `text`)}
          {this.renderCustomPhoneField(`Mobile`, mobilePhone, <PhoneIcon />, `mobilePhone`, `tel`)}
          {this.renderCustomPhoneField(`Phone`, primaryPhone, <PhoneIcon />, `primaryPhone`, `tel`)}
        </Grid>
      </Grid>
    );
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<ProfilePage />`
   * @memberof EditProfilePageComponent
   */
  render() {
    return this.renderProfile();
  }
}

/** @type {React.ComponentClass<EditProfilePageComponentProps>} */
const EditProfilePage = compose(
  withWidth(),
  withRouter,
  withStyles(themeCreateInjectableStyles(editProfilePageStyles), { withTheme: true }),
)(EditProfilePageComponent);

export default EditProfilePage;
